import { render, staticRenderFns } from "./device-warn-battery.vue?vue&type=template&id=f4ad836c&"
import script from "./device-warn-battery.vue?vue&type=script&lang=js&"
export * from "./device-warn-battery.vue?vue&type=script&lang=js&"
import style0 from "./device-warn-battery.vue?vue&type=style&index=0&id=f4ad836c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports